module.exports = __webpack_public_path__ + "static/media/mobil.7551a3ce.png";